import React from "react";
import { useNavigate } from "react-router-dom";

function ProductCardSearch({ viewStyle, name, link, price, img,button }) {
  const navigate = useNavigate();
  return (
    <div
      className={` mt-2 flex w-full ${
        viewStyle === true ? "flex-col items-center" : "flex-row h-auto  "
      }`}
    >
      <div
        className={`  ${
          viewStyle === true
            ? "  w-[250px] h-[300px]"
            : "  w-[400px] h-[250px] "
        }`}
      >
        <img src={img} className=" h-full " alt="Product Images" />
      </div>
      <div className="  w-full ">
        <div className=" h-full  flex flex-col justify-center   p-2">
          <p className="text-xs">{name}</p>
          {
            price!==undefined?<p className="text-xs mt-2">RS, {price}</p>:""
          }
          <button
            className={`mt-2 bg-black text-white ${viewStyle === false ? " w-[200px] " : " w-full "}   `}
            onClick={() => {
              navigate(link);
            }}
          >
            <strong className="text-xs">VIEW {button}</strong>
          </button>
        </div>
      </div>
    </div>
  );
}
export default ProductCardSearch;